import React, { useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ToastNotification from '../ToastNotification/ToastNotification';
import MainMenu from '../MainMenu/MainMenu';

const Login = () => {
    const navigate = useNavigate();
    
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [toast, setToast] = useState({ show: false, message: '', type: '' });
    const [isValidated, setIsValidated] = useState(false);
    const [userData, setUserData] = useState(null); // Armazena claims para o MainMenu

    const showMessage = (msg, type) => {
        setToast({ show: true, message: msg, type: type });
        setTimeout(() => setToast(prev => ({ ...prev, show: false })), 5000);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const response = await axios.post('https://phantomtech.com.br/AutomaTech/api/login/logon', {
                userName,
                password
            });

            if (response.status === 200) {
                const token = response.data.token;
                localStorage.setItem('@AutomaTech:token', token);

                // Decodifica as claims (userId e roles)
                const decoded = jwtDecode(token);
                setUserData({
                    userId: decoded.userId,
                    roles: decoded.roles
                });

                showMessage("Login realizado com sucesso!", "success");

                // Aguarda o toast antes de mudar a tela
                setTimeout(() => {
                    setIsValidated(true);
                }, 1500);
            }
        } catch (error) {
            const errorMsg = error.response?.data?.message || 'Falha no login: Verifique suas credenciais.';
            showMessage(errorMsg, 'error');
        } finally {
            setIsLoading(false);
        }
    };

    // Troca de tela condicional
    if (isValidated) {
        return <MainMenu user={userData} />;
    }

    return (
        <div className="container vh-100 d-flex justify-content-center align-items-center">
            <ToastNotification
                show={toast.show}
                message={toast.message}
                type={toast.type}
                onClose={() => setToast({ ...toast, show: false })}
            />

            <div className="col-12 col-md-8 col-lg-5">
                <div className="card shadow-sm">
                    <div className="card-body p-4">
                        <h3 className="card-title text-center mb-4">Acesso ao Sistema</h3>
                        
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label text-secondary small fw-bold">E-mail</label>
                                <input 
                                    type="email" 
                                    className="form-control" 
                                    placeholder="exemplo@email.com" 
                                    value={userName}
                                    onChange={(e) => setUserName(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label text-secondary small fw-bold">Senha</label>
                                <input 
                                    type="password" 
                                    className="form-control" 
                                    placeholder="******" 
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="d-grid gap-2 mb-3">
                                <button type="submit" className="btn btn-primary fw-bold" disabled={isLoading}>
                                    {isLoading ? (
                                        <><span className="spinner-border spinner-border-sm me-2"></span>Autenticando...</>
                                    ) : 'ENTRAR'}
                                </button>
                            </div>

                            <div className="d-flex flex-column flex-sm-row justify-content-between gap-2">
                                <button type="button" className="btn btn-link btn-sm text-decoration-none p-0 text-muted">
                                    Esqueci a senha
                                </button>
                                <button type="button" className="btn btn-outline-secondary btn-sm"
                                    onClick={() => navigate('/cadastrar-senha')}
                                >
                                    Cadastrar senha
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;